// The single "what does it actually feel like" figure, shared by the weather
// description, the food recommendations and the overlay line so the three can
// never disagree on screen (e.g. the panel calling a day "Hot" while the
// carousel serves cold-weather food).
//
// Heat index and wind chill are each only meaningful at one end of the scale —
// the stations report both at all times — so the apparent temperature takes
// whichever one is pushing away from comfortable:
//   warm side: heat index (humidity makes it feel hotter)
//   cool side: wind chill (wind makes it feel colder)

const WARM_SIDE_C = 20;

export function feelsLikeTemp(weatherData) {
  const { temperature, heatIndex, windChill } = weatherData || {};
  if (typeof temperature !== 'number' || !Number.isFinite(temperature)) return null;

  if (temperature >= WARM_SIDE_C) {
    return Number.isFinite(heatIndex) ? Math.max(temperature, heatIndex) : temperature;
  }
  return Number.isFinite(windChill) ? Math.min(temperature, windChill) : temperature;
}

// Is it raining now / about to? Shared by the recommendation scoring and the
// overlay copy.
export function isWet(weatherData) {
  const { rainChance, condition } = weatherData || {};
  return (rainChance ?? 0) > 60
    || Boolean(condition && condition.toLowerCase().includes('rain'));
}
